import { computeStreak, countCompletedSessions } from '../lib/exercise'
import { challengeDefinitions } from '../lib/challenges'

function Challenges({ plan, completion, challenges, onToggleChallenge }) {
  const streak = computeStreak(plan, completion)
  const sessions = countCompletedSessions(plan, completion)

  function autoProgress(def) {
    const current = def.metric === 'streak' ? streak : sessions
    return { current: Math.min(current, def.target), done: current >= def.target }
  }

  return (
    <main className="screen">
      <section className="dashboard-header">
        <p className="eyebrow">Ponete a prueba</p>
        <h1>Desafios</h1>
        <p className="subtitle">Objetivos extra ademas de tu rutina diaria.</p>
      </section>

      <ul className="exercise-list">
        {challengeDefinitions.map((def) => {
          if (def.type === 'auto') {
            const { current, done } = autoProgress(def)
            return (
              <li key={def.id} className={`exercise-row challenge-card ${done ? 'done' : ''}`}>
                <div className="challenge-card-head">
                  <h3>{def.title}</h3>
                  {done && <span className="challenge-badge">Cumplido</span>}
                </div>
                <p className="challenge-description">{def.description}</p>
                <div className="sheet-progress">
                  <div className="progress-track">
                    <div className="progress-fill" style={{ width: `${(current / def.target) * 100}%` }} />
                  </div>
                  <span>
                    {current}/{def.target}
                  </span>
                </div>
              </li>
            )
          }

          const done = Boolean(challenges[def.id])
          return (
            <li key={def.id} className={`exercise-row ${done ? 'done' : ''}`}>
              <label className="exercise-check">
                <input type="checkbox" checked={done} onChange={() => onToggleChallenge(def.id)} />
                <div className="exercise-row-body">
                  <span className="exercise-row-name">{def.title}</span>
                  <span className="exercise-row-meta">{def.description}</span>
                </div>
              </label>
            </li>
          )
        })}
      </ul>
    </main>
  )
}

export default Challenges
